import React from 'react';
import { CreditCard, FileDown } from 'lucide-react';
import { colors as theme } from '../theme';

// Shown to a client whose access is about to end (utils/subscriptionEnding.js): the date, and a
// way to the "Download my program" button in Settings. After a failed payment: a way to Settings,
// where "Manage subscription" updates the card.
const SubscriptionEndingNotice = ({ notice, onDownload, onUpdateCard }) => {
  if (!notice) return null;
  const paymentFailed = notice.kind === 'payment_failed';
  return (
    <div
      role="status"
      style={{
        margin: '12px 0 16px', padding: '12px 14px', borderRadius: '14px',
        border: '1px solid rgba(212, 175, 55, 0.6)', background: 'rgba(212, 175, 55, 0.08)',
      }}
    >
      <div style={{ color: theme.text, fontSize: '13px', lineHeight: 1.45 }}>{notice.text}</div>
      <button
        onClick={paymentFailed ? onUpdateCard : onDownload}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: '6px', marginTop: '10px', minHeight: '36px',
          padding: '6px 14px', borderRadius: '8px', border: `1px solid ${theme.gold}`, background: 'transparent',
          color: theme.gold, fontSize: '13px', fontWeight: 600, cursor: 'pointer',
        }}
      >
        {paymentFailed ? <CreditCard size={15} /> : <FileDown size={15} />}
        {paymentFailed ? 'Update my card' : 'Download my program'}
      </button>
    </div>
  );
};

export default SubscriptionEndingNotice;
